<form
class="form-inline search-full col"
[ngClass]="{ open: isSearchOpen }"
(clickOutside)="searchService.clickOutside()"
>
<div class="form-group w-100">
  <div class="Typeahead Typeahead--twitterUsers responsive-search">
    <div class="u-posRelative">
      <input
        class="demo-input Typeahead-input form-control-plaintext w-100 serch-input"
        [(ngModel)]="text"
        [ngModelOptions]="{ standalone: true }"
        (keydown.enter)="redirectToSearch($event.target)"
        (keyup)="findProducts(text)"
        type="text"
        placeholder="Search .."
      />
      <span (click)="isSearchOpen = !isSearchOpen">
        <app-feather-icons
          [class]="'close-search'"
          [icons]="'x'"
        ></app-feather-icons>
      </span>
    </div>
    @if (productList.length) {
      <div
        class="Typeahead-menu custom-scrollbar"
        [class.is-open]="searchResult"
        id="search-outer"
      >
        @for (product of productList | slice : 0 : 8; track product) {
        <div
          class="ProfileCard u-cf"
          [routerLink]="['/product', product._id]"
          (click)="removeFix()"
        >
          <div class="ProfileCard-details">
            <div class="ProfileCard-realName">
              <img [src]="product?.mainImage" class="img-course"/>
              <a class="realname">{{ product?.name }}</a>
            </div>
          </div>
        </div>
        }
      </div>
      }
        <!-- <div
          class="Typeahead-menu"
          [class.is-open]="searchService.searchResultEmpty"
          (clickOutside)="searchService.clickOutside()"
        >
        @for (product of productList | slice : 0 : 8; track product) {
          <div
            class="ProfileCard u-cf"
            [routerLink]="['/product', product.id]"
            (click)="removeFix()"
          >
            <div class="ProfileCard-details">
              <div class="ProfileCard-realName">
                <img [src]="product?.mainImage" class="img-course"/>
                <a class="realname">{{ product?.name }}</a>
              </div>
            </div>
          </div>
          }
          <div class="tt-dataset tt-dataset-0">
            <div class="EmptyMessage">
              Opps!! There are no result found.
            </div>
          </div>
        </div> -->
  </div>
</div>
</form>
<div
  class="Typeahead-menu is-open"
  [class.is-open]="searchResultEmpty"
  (clickOutside)="clickOutside()"
>
  <div class="tt-dataset tt-dataset-0">
    <div class="EmptyMessage">Opps!! There are no result found.</div>
  </div>
</div>